import { DateTimeRangeFilter, TableActionMenu, type TableActionItem } from '@/components/shared';

export interface OrganizationMembersFiltersProps {
  lastSeenFrom: string;
  lastSeenTo: string;
  addedFrom: string;
  addedTo: string;
  actions?: TableActionItem[];
  onLastSeenRangeChange: (from: string, to: string) => void;
  onAddedRangeChange: (from: string, to: string) => void;
}

export function OrganizationMembersFilters({
  lastSeenFrom,
  lastSeenTo,
  addedFrom,
  addedTo,
  actions = [],
  onLastSeenRangeChange,
  onAddedRangeChange,
}: OrganizationMembersFiltersProps) {
  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4">
      <DateTimeRangeFilter
        label="Last seen online"
        from={lastSeenFrom}
        to={lastSeenTo}
        onRangeChange={onLastSeenRangeChange}
      />

      <DateTimeRangeFilter
        label="Added date"
        from={addedFrom}
        to={addedTo}
        onRangeChange={onAddedRangeChange}
      />

      {actions.length > 0 ? (
        <div className="flex w-full justify-end md:ml-auto md:min-w-[14rem] md:flex-1">
          <TableActionMenu
            actions={actions}
            label="Organization members table actions"
            containerClassName="w-auto md:w-full"
          />
        </div>
      ) : null}
    </div>
  );
}
